/*eslint no-unused-vars: "off"*/

/**
 * @see: https://github.com/jaredpalmer/formik/tree/master/examples
 * @see: https://github.com/jaredpalmer/formik/issues/271, https://github.com/jaredpalmer/formik/issues/1633, @see: https://github.com/jaredpalmer/formik/issues/1218
 */
import React, { useState, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  TextField, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress, 
  Slider, Radio, RadioGroup, Checkbox, FormGroup, FormControlLabel, FormControl, FormLabel, 
  InputLabel, MenuItem, Select } from '@material-ui/core';

import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';

// s4n
import _ from 'lodash'
import ContextProductIndex from './../../../s4n/context/ProductIndex'
import { injectIntl } from "gatsby-plugin-intl"
import Preloader from './../../s4n/Preloader'
import classNames from 'classnames';
import Yup from './../../s4n/Yup';
import FormHelper from './../../s4n/Form'
import { DisplayFormikState } from "./../formikHelper"



const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 100,
    maxWidth: 150,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },

  success: {
    backgrounColor: "#4caf50",
    borderColor: "#4caf50",
  }
}));

const translation = {
  sort: {
      pl: `Sortowanie`,
      en: `Sort by`,
      de: `Sortiere nach`,
      es: `Ordenar por`,

      [`title_ASC`]: {
          pl: `Tytuł rosnąco`,
          en: `Title ascending`,
          de: `Titel aufsteigend`,
          es: `Título ascendente`,
      },
      [`title_DESC`]: {
          pl: `Tytuł malejąco`,
          en: `Title descending`,
          de: `Titel absteigend`,
          es: `Título descendente`,
      },
      [`variations.entity.price.number_ASC`]: {
          pl: `Cena rosnąco`,
          en: `Price ascending`,
          de: `Preis steigend`,
          es: `Precio ascendente`,
      },
      [`variations.entity.price.number_DESC`]: {
          pl: `Cena malejąco`,
          en: `Price descending`,
          de: `Preis fallend`,
          es: `Precio descendente`,
      },
  },
  limit: {
    pl: `Na stronie`,
    en: `Per page`,
    de: `Pro Seite`,
    es: `Por página`,
  }
}



const FormStateless = (props) => {
  const { intl } = props;
  const t = intl.formatMessage;

  // const { classes } = props; // export default withStyles(styles)(injectIntl(FormStateless))
  const classes = useStyles();

  // @see: https://stackoverflow.com/questions/53344755/how-to-run-setsubmitting-outside-the-submit-handler
  // const formikRef = React.createRef();

  const contextProductIndex = useContext(ContextProductIndex);

  // const [formStatus, setFormStatus] = useState({
  //   success: null,
  //   class: null,
  //   message: null,
  // });

  // const [state, setState] = useState({
  //   loading: false,
  //   error: false,
  // });

  let initialValues = {
    // sort: {id: `title_ASC`, field: `title`, direction: `ASC`},
    // limit: 12,
    // offset: 0,

    sort: contextProductIndex.filters.sort,
    limit: contextProductIndex.filters.limit,
    offset: contextProductIndex.filters.offset,
  }

  const validationSchema = Yup.object().shape({
    // name: Yup.string().required(),
    // email: Yup.string().email().required(),
    // message: Yup.string().required(),
  })

  const onValidate = (values) => {
      // console.log(`onValidate: `, values);
      onChange(values);
  }

  const onChange = (values) => {
      // console.log(`onChange: `, values);

      // actions.setSubmitting(true);
      // formikRef.current.setSubmitting(true);
      
      // actions.setStatus(undefined);
      contextProductIndex.updateFilters({
          ...values,
      });

      // actions.setSubmitting(false);
      // formikRef.current.setSubmitting(false);
  }

  const getInitialValuesFromContext = () => {
    const contextFiltersInitialValues = contextProductIndex.getFiltersInitial();
    const validResetObjectKeys = Object.keys(initialValues).filter(key => contextFiltersInitialValues.hasOwnProperty(key)); // === _.intersection(_.keys(initialValues), _.keys(contextFiltersInitialValues));

    const resetValues = {};
    validResetObjectKeys.forEach(key => {
      resetValues[key] = contextFiltersInitialValues[key];
    });

    return resetValues;
  }

  /**
   * @see: https://github.com/jaredpalmer/formik/issues/446
   * 
   * @param {*} values 
   * @param {*} actions 
   */
  const onReset = (values, actions) => {
      // console.log(`onReset: `, values);
      const resetValues = getInitialValuesFromContext();
      // console.log(resetValues);
      actions.resetForm(resetValues);
      values = resetValues;
      // actions.setSubmitting(true);
      onChange(values);
      // actions.setSubmitting(false);
  }

  const onSubmit = (values, actions) => {
      actions.setSubmitting(true);

      // actions.setStatus(undefined);
      contextProductIndex.updateFilters({
          ...values,
      });

      actions.setSubmitting(false);
  }

  const sort = [
    {id: `title_ASC`, field: `title`, direction: `ASC`},
    {id: `title_DESC`, field: `title`, direction: `DESC`},
    {id: `variations.entity.price.number_ASC`, field: `variations.entity.price.number`, direction: `ASC`},
    {id: `variations.entity.price.number_DESC`, field: `variations.entity.price.number`, direction: `DESC`},
  ];

  return (
    <React.Fragment>
      {/* {state.loading ?
        <Preloader /> 
        :  */}
        <Formik
          // ref={formikRef}
          enableReinitialize={true} // Thanks to this Formik will update when context (`contextProductIndex`) changes!!!, @see: https://github.com/jaredpalmer/formik/issues/811
          initialValues={initialValues}
          validationSchema={validationSchema}
          // onSubmit={onSubmit}
          // onChange={onChange} // no such listener
          // onReset={onReset}
          onReset={props.onReset}
          validate={onValidate} // @see: https://github.com/jaredpalmer/formik/issues/271#issuecomment-407869424
        >
          {(props) => {
            const {
              values,
              errors,
              status,
              touched,
              dirty,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
              handleReset,

              setFieldValue,
              submitForm,

            } = props;

            // console.log(status)

            // const formStatusClass = classNames({
            //   // "mb-0": true,
            //   "alert": true,
            //   "d-none": null === formStatus.class,
            //   [`alert-${formStatus.class}`]: true,
            // });

            return (
              <React.Fragment>
                <Form 
                  onSubmit={handleSubmit} 
                  // onChange={handleChange}
                  // className={initialValues.webform_id}
                  className="product-index-filter-top"

                  // onChange={() => console.log("test")}
                  // onChange={this.handleFormChange}

                >

                  {/* <DisplayFormikState {...props.values} /> */}

                  <div className="d-flex flex-wrap _flex-column _flex-lg-row">
                    {/* @see: https://material-ui.com/components/selects/ */}
                    <FormControl variant="filled" className={classes.formControl}>
                      <InputLabel htmlFor="filled-sort-simple">{translation.sort[intl.locale]}</InputLabel>
                      <Select
                        value={values.sort.id}
                        // onChange={handleChange}
                        onChange={(event, newValue) => {
                          // event.target.value === <MenuItem value=""
                          // handleChange(event)
                          // console.log(newValue)
                          const value = sort.filter(menuItem => menuItem.id === event.target.value);
                          // console.log(value[0])
                          setFieldValue(`sort`, value[0]);
                        }}
                        inputProps={{
                          name: 'sort',
                          id: 'filled-sort-simple',
                        }}
                        // autoWidth
                      >
                        {sort.map(menuItem => {
                          return (
                            <MenuItem 
                              // selected={values.sort.id == menuItem.id} 
                              key={menuItem.id} 
                              value={menuItem.id} 
                              name={menuItem.id}
                            >
                              {translation.sort[menuItem.id][intl.locale]}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>

                    {/* @see: https://material-ui.com/components/selects/ */}
                    <FormControl variant="filled" className={classes.formControl}>
                      <InputLabel htmlFor="filled-limit-simple">{translation.limit[intl.locale]}</InputLabel>
                      <Select
                        value={values.limit}
                        onChange={handleChange}
                        inputProps={{
                          name: 'limit',
                          id: 'filled-limit-simple',
                        }}
                        // autoWidth
                      >
                        {[12, 24, 48, 96].map((limit, index) => {
                            return (
                              <MenuItem key={limit} value={limit}>{limit}</MenuItem>
                            )
                        })}
                      </Select>
                    </FormControl>

                    {/* <div className="row">
                        <div className="col-md-4 mt-3">
                        </div>
                        <div className="col-md-8 text-right">
                            <a className="btn btn-blue-grey btn-sm waves-effect waves-light"><i className="fas fa-th mr-2"
                                    aria-hidden="true"></i><strong> Grid</strong></a>
                            <a className="btn btn-blue-grey btn-sm waves-effect waves-light"><i className="fas fa-th-list mr-2"
                                    aria-hidden="true"></i><strong> List</strong></a>
                        </div>
                    </div> */}

                    <DialogActions>
                        <Button
                          type="button"
                          color="secondary"
                          variant="contained"
                          className="outline"
                          onClick={handleReset}
                          // disabled={!dirty || isSubmitting} // @see: enableReinitialize={true}
                          // disabled={!touched || isSubmitting} // @see: enableReinitialize={true}
                          // disabled={_.isEqual(initialValues, getInitialValuesFromContext()) || isSubmitting} // @see: enableReinitialize={true}
                          disabled={_.isEqual(contextProductIndex.getFiltersInitial(), contextProductIndex.filters) || isSubmitting} // @see: enableReinitialize={true}
                        >{ t({ id: "soft4net_form_action_reset" }) }</Button>
                    </DialogActions>
                  </div>



                  {/* Form status messages */}
                  {/* <div className="row form-status">
                    <div className="col">
                      <div dangerouslySetInnerHTML={{ __html: formStatus.message }} className={formStatusClass} role="alert"></div>
                    </div>
                  </div> */}

                  {/* <div className="row">
                    <div className="col">
                      <DialogActions>
                        <Button
                          type="button"
                          color="secondary"
                          variant="contained"
                          className="outline"
                          onClick={handleReset}
                          disabled={!dirty || isSubmitting}
                        >{ t({ id: "soft4net_form_action_reset" }) }</Button>

                        {isSubmitting ? 
                          <CircularProgress /> : 
                          <Button 
                            type="submit" 
                            variant="contained" 
                            color="primary"
                            className={formStatus && formStatus.success ? 'green' : null}
                            disabled={isSubmitting}>{ t({ id: "soft4net_form_action_submit" }) }</Button>
                        }

                      </DialogActions>
                    </div>
                  </div> */}

                </Form>
                
                {/* <AutoSubmit values={values} submitForm={submitForm} /> */}

              </React.Fragment>
            );
          }}
        </Formik>
      {/* } */}
      </React.Fragment>
    )
}

// export default withStyles(styles)(injectIntl(FormStateless))
export default injectIntl(FormStateless)